import { emptyPatterns, flatten, union } from '../lib/shapePatterns.js';
import Shape from './Shape.js';
import * as Rule from './rule/Rule.js';
export default class extends Shape {
    constructor(targets, properties, constraints, rules) {
        super(constraints);
        this.targets = targets;
        this.properties = properties;
        this.rules = rules;
    }
    buildPatterns({ focusNode, ...arg }) {
        let targets = emptyPatterns;
        if (focusNode.termType === 'Variable') {
            targets = union(...this.targets.flatMap(target => target.buildPatterns({
                ...arg,
                focusNode,
            })));
        }
        const rootPatterns = [...arg.rootPatterns, ...targets.whereClause];
        let properties = emptyPatterns;
        if (this.properties.length) {
            properties = this.properties.reduce(Rule.union({ ...arg, focusNode, rootPatterns }), emptyPatterns);
        }
        let rules = emptyPatterns;
        if (this.rules.length) {
            rules = this.rules.reduce(Rule.union({ ...arg, focusNode, rootPatterns }), emptyPatterns);
        }
        const logical = this.buildLogicalConstraints({ ...arg, focusNode, rootPatterns });
        return flatten(targets, union(properties, rules), logical);
    }
    buildConstraints(arg) {
        return this.constraints.flatMap(c => c.buildPatterns(arg));
    }
}
